import {calculateFinalPriceConcierge} from '@/utils/index.js'
import moment from 'moment'
import router from '../../router'

export default{
	state:{
		upsell_ref:{
			id: '',
			type: '',
    	module: '',
    	reservation_id: '',
    	created_at: ''
		},
		voucher_order: {
			cart: [],
			promo_code: ''
		},
		voucher_page_module: '',
		voucher_group_id: ''
	},
	getters:{
		getUpsellRef: state => state.upsell_ref,
		getVoucherPageModule: state => state.voucher_page_module,
		getVoucherOrder: state => state.voucher_order,
		getVoucherGroupId: state => state.voucher_group_id,
		getVoucherOrderTotal: state => {
			let total = 0
			for(let pos of state.voucher_order.cart){
				for(let product of pos.product){
					if(product.is_variant){
						for(let variant of product.variant_list){
							total += calculateFinalPriceConcierge(variant.data.price) * variant.qty
						}
					}else{
						total += calculateFinalPriceConcierge(product.data.price) * product.qty
					}
				}

			}
			return total
		},
		getVoucherOrderTotalPromo: state => {
			let total = 0
			for(let pos of state.voucher_order.cart){
				for(let product of pos.product){
					if(product.is_variant){
						for(let variant of product.variant_list){
							if(variant.data.price.promotion_amount > 0 && variant.data.price.promotion_type == 'DECREASE'){
								total += variant.data.price.promotion_amount * variant.qty
							}
						}
					}else{
						if(product.data.price.promotion_amount > 0 && product.data.price.promotion_type == 'DECREASE'){
							total += product.data.price.promotion_amount * product.qty
						}
					}
				}
			}
			return total
		},
		getVoucherOrderSubTotal: state => {
			let total = 0
			for(let pos of state.voucher_order.cart){
				for(let product of pos.product){
					if(product.is_variant){
						for(let variant of product.variant_list){
							if(variant.data.price.promotion_amount > 0 && variant.data.price.promotion_type == 'INCREASE'){
								total += (variant.data.price.price_sell+variant.data.price.promotion_amount) * variant.qty
							}else{
								total += variant.data.price.price_sell * variant.qty
							}
						}
					}else{
						if(product.data.price.promotion_amount > 0 && product.data.price.promotion_type == 'INCREASE'){
							total += (product.data.price.price_sell+product.data.price.promotion_amount) * product.qty
						}else{
							total += product.data.price.price_sell * product.qty
						}
					}
				}

			}
			return total
		},
		getVoucherOrderTotalQty: state => {
			let total = 0
			for(let pos of state.voucher_order.cart){
				for(let product of pos.product){
					total += product.qty
				}

			}
			return total
		},
	},
	mutations:{
		setUpsellRef: (state,payload='reset') => {
			if(payload == 'reset'){
    		state.upsell_ref = {
    			id: '',
    			type: '',
					module: '',
					reservation_id: '',
					created_at: ''
    		}
    	}else{
    		state.upsell_ref = {
    			id: payload.id,
    			type: payload.type,
					module: payload.module,
					reservation_id: payload.reservation_id,
					created_at: moment().format()
    		}
    	}
		},
		setUpsellRsv: (state,payload) => {
			state.upsell_rsv = payload
		},
		setVoucherGroupId: (state,payload) => {
			state.voucher_group_id = payload
		},
		setVoucherPageModule(state,payload){
			state.voucher_page_module = payload
		},
		setVoucherOrder: (state,payload) => {
			// FIND POS_ID
			let current_route = router.currentRoute

			if(state.voucher_order.cart.length == 0){
				state.voucher_page_module = current_route.name
			}
			
			let pos_i = state.voucher_order.cart.findIndex(el=>el.pos.id == payload.product.merchant_pos.id)
			if(pos_i == -1){
				let copied_data = JSON.parse(JSON.stringify(payload))
				delete copied_data.product.variant_list
				let is_variant = payload.product.variant_list.length > 0 ? true : false 
				let new_data = {
					pos: payload.product.merchant_pos,
					product:[{
						data: copied_data.product,
						is_variant: is_variant,
						variant_list: !is_variant ? [] : [{
							data: copied_data.variant,
							qty: payload.qty,
							notes: ''
						}],
						notes: '',
						qty: payload.qty
					}]
				}
				state.voucher_order.cart.push(new_data)
			}else{
				// FIND PRODUCT
				let product_i = state.voucher_order.cart[pos_i].product.findIndex(el=>el.data.id == payload.product.id)
				if(product_i == -1){
					let is_variant = payload.product.variant_list.length > 0 ? true : false
					state.voucher_order.cart[pos_i].product.push({
						data: payload.product,
						is_variant: is_variant,
						variant_list: !is_variant ? [] : [{
							data: payload.variant,
							qty: payload.qty,
							notes: ''
						}],
						notes: '',
						qty: payload.qty
					})					
				}else{
					if(state.voucher_order.cart[pos_i].product[product_i].is_variant){
						// FIND VARIANT
						let variant_i = state.voucher_order.cart[pos_i].product[product_i].variant_list.findIndex(el=>el.data.id == payload.variant.id)
						if(variant_i == -1){
							state.voucher_order.cart[pos_i].product[product_i].variant_list.push({
								data: payload.variant,
								qty: payload.qty,
								notes: ''
							})
							state.voucher_order.cart[pos_i].product[product_i].qty += payload.qty
						}else{
							state.voucher_order.cart[pos_i].product[product_i].qty -= state.voucher_order.cart[pos_i].product[product_i].variant_list[variant_i].qty
							state.voucher_order.cart[pos_i].product[product_i].variant_list[variant_i].qty = payload.qty
 							state.voucher_order.cart[pos_i].product[product_i].qty += state.voucher_order.cart[pos_i].product[product_i].variant_list[variant_i].qty
						}
					}else{
						state.voucher_order.cart[pos_i].product[product_i].qty = payload.qty
					}
				}
			}
		},
		removeVoucherOrder: (state,payload) => {
			let pos_i = state.voucher_order.cart.findIndex(el=>el.pos.id == payload.product.merchant_pos.id)
			if(pos_i != -1){
				let product_i = state.voucher_order.cart[pos_i].product.findIndex(el=>el.data.id == payload.product.id)
				if(product_i != -1){
					if(state.voucher_order.cart[pos_i].product[product_i].is_variant){
						let variant_i = state.voucher_order.cart[pos_i].product[product_i].variant_list.findIndex(el=>el.data.id == payload.variant.id)
						if(variant_i != -1){
							let temp_qty = state.voucher_order.cart[pos_i].product[product_i].variant_list[variant_i].qty
							state.voucher_order.cart[pos_i].product[product_i].variant_list.splice(variant_i,1)
							state.voucher_order.cart[pos_i].product[product_i].qty -= temp_qty
							if(state.voucher_order.cart[pos_i].product[product_i].variant_list.length == 0){
								state.voucher_order.cart[pos_i].product.splice(product_i,1)
								if(state.voucher_order.cart[pos_i].product.length == 0){
									state.voucher_order.cart.splice(pos_i,1)
								}
							}
						}else{
							console.error('VARIANT NOT FOUND')
						}
					}else{
						state.voucher_order.cart[pos_i].product.splice(product_i,1)
						if(state.voucher_order.cart[pos_i].product.length == 0){
							state.voucher_order.cart.splice(pos_i,1)
						}
					}
				}else{
					console.error('PRODUCT NOT FOUND')
				}

				if(state.voucher_order.cart.length == 0){
					state.voucher_page_module = ''
				}
			}
		} ,
		setVoucherOrderPromoCode: (state,payload) => {
			state.voucher_order.promo_code = payload
		},
		setSpecificVoucherOrder: (state,payload) => {
			let pos_i = state.voucher_order.cart.findIndex(el=>el.pos.id == payload.merchant_pos_id)
			if(pos_i != -1){
				let cart_product = state.voucher_order.cart[pos_i].product[payload.index_product]
				if(payload.is_variant){
					let cart_variant = cart_product.variant_list[payload.index_variant]
					if(cart_variant.data.promotion_affected.best == null || (cart_variant.data.promotion_affected.best != null && cart_variant.data.promotion_affected.best.promotion_type != "PROMO_CODE")){
						cart_variant.old_data = JSON.parse(JSON.stringify(cart_variant.data))
					}
					cart_variant.data = payload.data
				}else{
					if(cart_product.data.promotion_affected.best == null || (cart_product.data.promotion_affected.best != null && cart_product.data.promotion_affected.best.promotion_type != "PROMO_CODE")){
						cart_product.old_data = JSON.parse(JSON.stringify(cart_product.data))
					}
					cart_product.data = payload.data
				}
			}
		},
		resetSpecificVoucherOrder: (state,payload) => {
			let pos_i = state.voucher_order.cart.findIndex(el=>el.pos.id == payload.merchant_pos_id)
			if(pos_i != -1){
				let cart_product = state.voucher_order.cart[pos_i].product[payload.index_product]
				if(payload.is_variant){
          const oldData = cart_product.variant_list[payload.index_variant].old_data
          if(oldData){
            cart_product.variant_list[payload.index_variant].data = JSON.parse(JSON.stringify(oldData))
            delete cart_product.variant_list[payload.index_variant].old_data
          }
				}else{
          if(cart_product.old_data){
            cart_product.data = JSON.parse(JSON.stringify(cart_product.old_data))
            delete cart_product.old_data
          }
				}
			}
		},
		resetVoucherOrder: (state) => {
			state.voucher_order = {
				cart: [],
				promo_code: ''
			}
			state.voucher_page_module = ''
		},
		resetAllDataMarketing(state){
			state.upsell_ref={
				id: '',
				type: '',
				module: '',
				reservation_id: '',
				created_at: ''
			}
			state.voucher_order= {
				cart: [],
				promo_code: ''
			}
			state.voucher_group_id = ''
			state.voucher_page_module = ''
      state.voucher_group_id = ''
		}
	}
}


// WEBPACK FOOTER //
// ./src/store/modules/marketing.js